import React, { useEffect, useState } from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { useFormik } from "formik";
import Spinner from 'react-bootstrap/Spinner';
import useImageUploader from "../hooks/UploadImage";
import { getRequest, postRequest, putRequest } from "../services/apiMethods";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { EmployeeValidationSchema } from "../utils/Validations";
import ConfirmModal from "../Modal/ConfirmModal";
import moment from "moment";
import toast from "react-hot-toast";

export default function Employee() {
  const location = useLocation();
  const Navigate = useNavigate();
  const queryClient = useQueryClient();
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("");

  const handleDelete = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  const handleConfirmClose = async () => {
    setModalOpen(false);
  };

  const { uploadImage, loading, error, uploadedUrl, errorMessage } = useImageUploader();  // Call the hook here


  // Initial form values
  const initialValues = {
    employeeName: "",
    jobRole: "",
    // joiningDate: "",
    qualification: "",
    image: null,

  };

  const { data: employeeDetails, error: employeeDetailsError, isLoading: employeeDetailsLoading } = useQuery({
    queryKey: ["employeeDetails"],
    queryFn: () => getRequest(`/employee/details${location?.search}`),
    enabled: !!location?.search,
  });

  useEffect(() => {
    if (!location?.search) {
      queryClient.setQueryData(["employeeDetails"], null);
    }
  }, [location?.search, queryClient]);


  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      if (location?.search) {
        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get('employeeId'); // Get the 'id' query param
        const modifyData = {
          id: id,
          employeeName: data?.employeeName || "",
          jobRole: data?.jobRole || "",
          // joiningDate: data?.joiningDate || "",
          qualification: data?.qualification || "",
          image: data?.image || "",
        };
        return putRequest(`/employee/edit`, modifyData);
      } else {
        const modifyData = {
          employeeName: data?.employeeName || "",
          jobRole: data?.jobRole || "",
          // joiningDate: data?.joiningDate || "",
          qualification: data?.qualification || "",
          image: data?.image || "",
        };
        return postRequest(`/employee/create`, modifyData);
      }

    },
    onSuccess: (data) => {
      toast.success(`${data?.message}`, {
        iconTheme: {
          primary: '#337FE0',
          secondary: '#FFFAEE',
        },
      })
      Navigate(-1);
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });


  // Handle form submission
  const handleSubmit = (values) => {
    mutate(values);
  };

  // Using useFormik hook
  const formik = useFormik({
    initialValues: employeeDetails?.data || initialValues,
    enableReinitialize: true,
    validationSchema:EmployeeValidationSchema,
    onSubmit: handleSubmit,
  });


  useEffect(() => {
    if (uploadedUrl) {
      formik.setFieldValue("image", uploadedUrl); // Set the uploaded image URL
    }
  }, [uploadedUrl])

  return (
    <Layout>
      <Container>
        <div className="dashboard-main">
          <h3
            className="with-back-btn cursor-pointer"
            onClick={() => Navigate(-1)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                fill="black"
              />
            </svg>
            Employees
          </h3>
          <Row>
            <Col lg={8}>
              <div className="my-profile-card-contain">
                <div className="my-profile-title">
                  <h4>Employees </h4>
                </div>
                <div className="my-profile-box-contain">
                  <div className="my-profile-box-form">
                    <div className="h-100 m-0">
                      <Form className="cmn-form-set" onSubmit={formik.handleSubmit}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Employee Photo</Form.Label>
                          <div className="cmpny-logo-upld">
                          {loading ?
                              <span className="dot">
                                <Spinner as="span" animation="border" variant="primary" size="sm" role="status" aria-hidden="true" />
                              </span>

                              :
                            <img
                              src={formik.values.image ? formik.values.image : require("../assets/images/vector-logo.svg").default}
                              alt="Employee"
                              style={{ width: "100px", height: "100px", objectFit: "cover" }}
                            />
                          }
                            <div>
                              <div className="cmpny-logo-upld">
                                <Form.Control
                                  type="file"
                                  name="image"
                                  accept="image/*"
                                  onChange={async (event) => {
                                    const file = event.target.files[0];
                                    if (file) {
                                      await uploadImage(file); // Wait for image upload
                                      formik.setFieldValue("image", uploadedUrl); // Set the uploaded image URL
                                    }
                                  }}
                                />
                                <button className="white-btn" disabled={loading}>
                                  Upload Photo
                                </button>
                              </div>
                              <Form.Text className="text-muted">
                                500 x 500 recommended
                              </Form.Text>
                            </div>
                          </div>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="employeeName">
                          <Form.Label>Employee Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Type here"
                            name="employeeName"
                            value={formik.values.employeeName}
                            // onChange={formik.handleChange}
                            onChange={(e) => {
                              let value = e.target.value.replace(/^\s+/, ""); // Remove leading spaces
                              value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              formik?.setFieldValue("employeeName", value);
                            }}
                            onBlur={formik.handleBlur}
                            isInvalid={formik.touched.employeeName && !!formik.errors.employeeName}
                          />
                          {formik.touched.employeeName && formik.errors.employeeName && (
                            <Form.Control.Feedback type="invalid">
                              {formik.errors.employeeName}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="jobRole">
                          <Form.Label>Job Role</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Type here"
                            name="jobRole"
                            value={formik.values.jobRole}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={formik.touched.jobRole && !!formik.errors.jobRole}
                          />
                          {formik.touched.jobRole && formik.errors.jobRole && (
                            <Form.Control.Feedback type="invalid">
                              {formik.errors.jobRole}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>



                        <Form.Group className="mb-3" controlId="qualification">
                          <Form.Label>Qualifications </Form.Label>
                          <Form.Control
                          as="textarea"
                           rows={3}
                            placeholder="Type here"
                            name="qualification"
                            value={formik.values.qualification}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={formik.touched.qualification && !!formik.errors.qualification} 
                          />
                          {formik.touched.qualification && formik.errors.qualification && (
                            <Form.Control.Feedback type="invalid">
                              {formik.errors.qualification}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>





                        {/* <Form.Group className="mb-3" controlId="joiningDate">
                          <Form.Label>Joining Date</Form.Label>
                          <Form.Control
                            type="date"
                            name="joiningDate"
                            value={formik.values.joiningDate ? moment(formik.values.joiningDate).format('YYYY-MM-DD') : ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={formik.touched.joiningDate && !!formik.errors.joiningDate}
                            max={moment().format('YYYY-MM-DD')} // Disable future dates
                          />
                          {formik.touched.joiningDate && formik.errors.joiningDate && (
                            <Form.Control.Feedback type="invalid">
                              {formik.errors.joiningDate}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="educationLevel">
                          <Form.Label>Education Level</Form.Label>
                          <Form.Select
                            aria-label="Default select example"
                            name="educationLevel"
                            value={formik.values.educationLevel}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={formik.touched.educationLevel && !!formik.errors.educationLevel}
                          >
                            <option>Select</option>
                            <option value="GCSE">GCSE</option>
                            <option value="NVQ Level 2">NVQ Level 2</option>
                            <option value="NVQ Level 3">NVQ Level 3</option>
                            <option value="Apprenticeship">Apprenticeship</option>
                            <option value="Degree">Degree </option>
                            <option value="HNC/HND">HNC/HND Engineering</option>
                            <option value="None">None</option>
                          </Form.Select>
                          {formik.touched.educationLevel && formik.errors.educationLevel && (
                            <Form.Control.Feedback type="invalid">
                              {formik.errors.educationLevel}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group> */}

                        <div className="d-flex gap-4">
                          <button type="submit" className="theme-comm-btn">
                            Save
                          </button>
                          {location.search &&
                          <button type="button" className="theme-red-comm-btn" onClick={()=>handleDelete("employee")} >
                              Delete
                            </button>}
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={4}></Col>
          </Row>
        </div>
      </Container>
      <ConfirmModal
        data={location.search}
        isModalOpen={isModalOpen}
        selectedType={selectedType}
        handleConfirmClose={handleConfirmClose}
      />
    </Layout>
  );
}
